// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}

.footer-lang {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: max-content;
  margin: 0 auto;
  padding: 0;
  gap: 0px;
  border: 2px solid var(--ion-color-tertiary);
  border-radius: var(--radius-default);
}
.footer-lang .item {
  text-align: center;
  background: var(--ion-color-tertiary);
  border-radius: 0;
  overflow: hidden;
  padding: 10px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: -moz-fit-content;
  width: fit-content;
  gap: 10px;
}
.footer-lang .item p {
  font-family: AppFontMedium;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.02em;
  vertical-align: middle;
  text-transform: uppercase;
  color: var(--ion-color-primary);
}
.footer-lang .item ion-icon {
  height: 24px;
  width: 24px;
  border: 1px solid var(--ion-color-tertiary);
  border-radius: 50px;
}
.footer-lang div.selected {
  background: var(--ion-color-primary);
}
.footer-lang div.selected p {
  color: var(--ion-color-primary-contrast);
}
.footer-lang div.selected ion-icon {
  border: 1px solid var(--ion-color-primary-contrast);
}

.from_menu .item {
  background: transparent;
  border: 1px solid var(--ion-color-primary);
}`, "",{"version":3,"sources":["webpack://./src/app/components/lang-switcher/lang-switcher.scss"],"names":[],"mappings":"AAAA;EACC,cAAA;AACD;;AACA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;EACA,UAAA;EACA,QAAA;EACA,2CAAA;EACA,oCAAA;AAED;AAAC;EACC,kBAAA;EACA,qCAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,SAAA;AAEF;AADE;EACC,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,sBAAA;EACA,yBAAA;EAEA,+BAAA;AAEH;AAAE;EACC,YAAA;EACA,WAAA;EACA,2CAAA;EACA,mBAAA;AAEH;AAEE;EACC,oCAAA;AAAH;AAEG;EACC,wCAAA;AAAJ;AAGG;EACC,mDAAA;AADJ;;AAQC;EACC,uBAAA;EACA,0CAAA;AALF","sourcesContent":[":host {\n\tdisplay: block;\n}\n.footer-lang {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tmax-width: max-content;\n\tmargin: 0 auto;\n\tpadding: 0;\n\tgap: 0px;\n\tborder: 2px solid var(--ion-color-tertiary);\n\tborder-radius: var(--radius-default);\n\n\t.item {\n\t\ttext-align: center;\n\t\tbackground: var(--ion-color-tertiary);\n\t\tborder-radius: 0;\n\t\toverflow: hidden;\n\t\tpadding: 10px 16px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\twidth: fit-content;\n\t\tgap: 10px;\n\t\tp {\n\t\t\tfont-family: AppFontMedium;\n\t\t\tfont-size: 14px;\n\t\t\tline-height: 16px;\n\t\t\tletter-spacing: 0.02em;\n\t\t\tvertical-align: middle;\n\t\t\ttext-transform: uppercase;\n\n\t\t\tcolor: var(--ion-color-primary);\n\t\t}\n\t\tion-icon {\n\t\t\theight: 24px;\n\t\t\twidth: 24px;\n\t\t\tborder: 1px solid var(--ion-color-tertiary);\n\t\t\tborder-radius: 50px;\n\t\t}\n\t}\n\tdiv {\n\t\t&.selected {\n\t\t\tbackground: var(--ion-color-primary);\n\n\t\t\tp {\n\t\t\t\tcolor: var(--ion-color-primary-contrast);\n\t\t\t}\n\n\t\t\tion-icon {\n\t\t\t\tborder: 1px solid var(--ion-color-primary-contrast);\n\t\t\t}\n\t\t}\n\t}\n}\n\n.from_menu {\n\t.item {\n\t\tbackground: transparent;\n\t\tborder: 1px solid var(--ion-color-primary);\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
